import { Box, Stepper, styled } from '@mui/material';

const ScrollableContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isExpanded',
})<{ isExpanded?: boolean }>(({ isExpanded }) => ({
  height: isExpanded ? '662px' : '300px', // Fixed height when expanded to match max content height, fixed when collapsed
  overflowY: isExpanded ? 'visible' : 'auto',
  overflowX: 'hidden',
  width: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#ccc',
    borderRadius: '3px',
    '&:hover': {
      background: '#999',
    },
  },
}));

const StyledStepper = styled(Stepper)({
  width: '100%',
});

export { ScrollableContainer, StyledStepper };
